import { supreme } from '@/supreme-core'
import { cancelCollectCar, collectCar } from '@/model'
import util from '@/util/util'
import store from '../index'

let state = {
	data: null,

	// 收藏状态的改变要全局存储,帮助首页更新
	collectedRecord: localStorage.getItem('collectRecord')
		? JSON.parse(localStorage.getItem('collectRecord'))
		: [],
	cancelCollectRecord: localStorage.getItem('cancelCollectRecord')
		? JSON.parse(localStorage.getItem('cancelCollectRecord'))
		: []
}

let mutations = {
	setData(state, data) {
		state.data = data
	},

	collect(state, skuCode) {
		state.cancelCollectRecord = state.cancelCollectRecord.filter(one => one !== skuCode)
		state.collectedRecord.push(skuCode)
		localStorage.setItem('cancelCollectRecord', JSON.stringify(state.cancelCollectRecord))
		localStorage.setItem('collectedRecord', JSON.stringify(state.collectedRecord))
	},

	cancelCollect(state, skuCode) {
		state.collectedRecord = state.collectedRecord.filter(one => one !== skuCode)
		state.cancelCollectRecord.push(skuCode)

		localStorage.setItem('cancelCollectRecord', JSON.stringify(state.cancelCollectRecord))
		localStorage.setItem('collectedRecord', JSON.stringify(state.collectedRecord))
	},

	cleanCollectState() {
		localStorage.setItem('cancelCollectRecord', JSON.stringify([]))
		localStorage.setItem('collectedRecord', JSON.stringify([]))

		state.collectedRecord = []
		state.cancelCollectRecord = []
	},

	syncCollectState(state) {
		if (localStorage.getItem('cancelCollectRecord')) {
			state.cancelCollectRecord = JSON.parse(localStorage.getItem('cancelCollectRecord'))
		} else {
			state.cancelCollectRecord = []
		}

		if (localStorage.getItem('collectedRecord')) {
			state.collectedRecord = JSON.parse(localStorage.getItem('collectedRecord'))
		} else {
			state.collectedRecord = []
		}
	}
}

let actions = {
	async switchCollect(context, { commodity_code, curCollected }) {
		if (curCollected) {
			const res = await cancelCollectCar.post({ commodity_code })
			if (res.data.result_code !== 'success') {
				throw new Error(res.data.display_msg)
			}
			context.commit('cancelCollect', commodity_code)
		} else {
			const res = await collectCar.post({ commodity_code })

			if (res.data.result_code !== 'success') {
				throw new Error(res.data.display_msg)
			}

			context.commit('collect', commodity_code)
		}
	}
}

let oldToken = util.getToken()

document.addEventListener('visibilitychange', () => {
	const newToken = util.getToken()
	if (newToken !== oldToken) {
		store.commit('homeState/cleanCollectState')
	} else {
		store.commit('homeState/syncCollectState')
	}
})

export default {
	namespaced: true,
	state: state,
	mutations: mutations,
	actions
}
